exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-gallery-item-tsx": () => import("./../../../src/templates/galleryItem.tsx" /* webpackChunkName: "component---src-templates-gallery-item-tsx" */)
}

